import Api from './Api';

class _ClientApi extends Api {
    loadClients(): Promise<any> {
        return this.getHttpClient().get(`client/list`);
    }

    loadClient(id: number): Promise<any> {
        return this.getHttpClient().get(`client/detail/${id}`);
    }

    deleteProject(project_id: number): Promise<any> {
        return this.getLocalHttpClient().delete(`projects/${project_id}`);
    }
}

export const ClientApi = new _ClientApi();
